"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Icon = require("../Icon");

var _theme = require("../../theme");

const Container = _styledComponents.default.div.withConfig({
  displayName: "Loaderstyles__Container"
})(["display:inline-flex;flex-shrink:0;color:", ";&,", "{width:", ";height:", ";}"], _ref => {
  let {
    color
  } = _ref;
  return (0, _theme.themeColor)(color);
}, _Icon.IconStyled, _ref2 => {
  let {
    size
  } = _ref2;
  return (0, _theme.rem)(size);
}, _ref3 => {
  let {
    size
  } = _ref3;
  return (0, _theme.rem)(size);
});

exports.Container = Container;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJDb250YWluZXIiLCJzdHlsZWQiLCJkaXYiLCJjb2xvciIsInRoZW1lQ29sb3IiLCJJY29uU3R5bGVkIiwic2l6ZSIsInJlbSJdLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0xvYWRlci9Mb2FkZXIuc3R5bGVzLnRzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnc3R5bGVkLWNvbXBvbmVudHMnXG5pbXBvcnQgeyBJY29uU3R5bGVkIH0gZnJvbSAnfmNvbXBvbmVudHMvSWNvbidcbmltcG9ydCB7IHJlbSwgdGhlbWVDb2xvciB9IGZyb20gJ350aGVtZSdcbmltcG9ydCB7IExvYWRlckNvbG9yIH0gZnJvbSAnLi9Mb2FkZXIudHlwZXMnXG5cbmludGVyZmFjZSBDb250YWluZXJQcm9wcyB7XG4gIHNpemU6IG51bWJlclxuICBjb2xvcjogTG9hZGVyQ29sb3Jcbn1cblxuZXhwb3J0IGNvbnN0IENvbnRhaW5lciA9IHN0eWxlZC5kaXY8Q29udGFpbmVyUHJvcHM+YFxuICBkaXNwbGF5OiBpbmxpbmUtZmxleDtcbiAgZmxleC1zaHJpbms6IDA7XG4gIGNvbG9yOiAkeyh7IGNvbG9yIH0pID0+IHRoZW1lQ29sb3IoY29sb3IpfTtcblxuICAmLFxuICAke0ljb25TdHlsZWR9IHtcbiAgICB3aWR0aDogJHsoeyBzaXplIH0pID0+IHJlbShzaXplKX07XG4gICAgaGVpZ2h0OiAkeyh7IHNpemUgfSkgPT4gcmVtKHNpemUpfTtcbiAgfVxuYFxuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFBQTs7QUFDQTs7QUFDQTs7QUFRTyxNQUFNQSxTQUFTLEdBQUdDLHlCQUFBLENBQU9DLEdBQVY7RUFBQTtBQUFBLHFGQUdYO0VBQUEsSUFBQztJQUFFQztFQUFGLENBQUQ7RUFBQSxPQUFlLElBQUFDLGlCQUFBLEVBQVdELEtBQVgsQ0FBZjtBQUFBLENBSFcsRUFNbEJFLGdCQU5rQixFQU9UO0VBQUEsSUFBQztJQUFFQztFQUFGLENBQUQ7RUFBQSxPQUFjLElBQUFDLFVBQUEsRUFBSUQsSUFBSixDQUFkO0FBQUEsQ0FQUyxFQVFSO0VBQUEsSUFBQztJQUFFQTtFQUFGLENBQUQ7RUFBQSxPQUFjLElBQUFDLFVBQUEsRUFBSUQsSUFBSixDQUFkO0FBQUEsQ0FSUSxDQUFmIn0=